module.exports = __webpack_public_path__ + "static/media/rvnotificationOn.4160e2d3.svg";